module.exports = __webpack_public_path__ + "media/images/home/delivery-931cdea2f9cb8894d5c215c4e3f1c167.png";